import { AsyncThunk } from "@reduxjs/toolkit";

type ThunkStatus = "pending" | "fulfilled" | "rejected";

export function matchThunkStatus(
  thunks: AsyncThunk<any, any, any>[],
  status: ThunkStatus
) {
  const types = thunks.map((thunk) => thunk[status].type);
  return (action: { type: string }) => types.includes(action.type);
}
